import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import IncreaseRevenue from './pages/IncreaseRevenue';
import ReduceCosts from './pages/ReduceCosts';
import ImproveEfficiency from './pages/ImproveEfficiency';
import EnhanceCustomerExperience from './pages/EnhanceCustomerExperience';
import AccelerateDecisions from './pages/AccelerateDecisions';
import OurApproach from './pages/OurApproach';
import WhyUs from './pages/WhyUs';
import ROICalculator from './pages/ROICalculatorNutra';
import NutraceuticalAIPlan from './pages/NutraceuticalAIPlan';
import CostOfInaction from './pages/CostOfInaction';
import CaseStudies from './pages/CaseStudies';
import Resources from './pages/Resources';
import GetStarted from './pages/GetStarted';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import KnowledgeCenter from './pages/KnowledgeCenter';
import PremiumFloatingButton from './components/PremiumFloatingButton';
import ScrollProgress from './components/ScrollProgress';
import LoadingScreen from './components/LoadingScreen';
import CustomCursor from './components/CustomCursor';
import BackToTop from './components/BackToTop';
import AIReadiness from './pages/AIReadiness';
import AIStrategyRoadmap from './pages/AIStrategyRoadmap';
import DataAudit from './pages/DataAudit';
import UseCaseIdentification from './pages/UseCaseIdentification';
import ProjectScopingROI from './pages/ProjectScopingROI';
// Removed unused IndustryBenchmarking import
import IndustryReports from './pages/IndustryReports';
import FutureMarketInsights from './pages/FutureMarketInsights';
import ChatbotsAgents from './pages/dev/ChatbotsAgents';
import WorkflowAutomation from './pages/dev/WorkflowAutomation';
import IntelligentDocumentProcessing from './pages/dev/IntelligentDocumentProcessing';
import GenerativeAIIntegration from './pages/dev/GenerativeAIIntegration';
import ComingSoon from './pages/ComingSoon';
import BenchmarkingCalculator from './pages/BenchmarkingCalculator';
import BlogControlPanel from './pages/BlogControlPanel';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingScreen onComplete={() => setIsLoading(false)} />;
  }

  return (
    <Router>
      <div className="App">
        <CustomCursor />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/web" element={<Services />} />
          <Route path="/services/mobile" element={<Services />} />
          <Route path="/services/cloud" element={<Services />} />
          <Route path="/services/security" element={<Services />} />
          <Route path="/services/consulting" element={<Services />} />
          <Route path="/services/ai-apps" element={<Services />} />
          <Route path="/services/dev/apps" element={<Services />} />
          <Route path="/services/api-integration" element={<Services />} />
          <Route path="/services/dev/api" element={<Services />} />
          <Route path="/services/dev/api-integration" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/increase-revenue" element={<IncreaseRevenue />} />
          <Route path="/reduce-costs" element={<ReduceCosts />} />
          <Route path="/improve-efficiency" element={<ImproveEfficiency />} />
          <Route path="/enhance-customer-experience" element={<EnhanceCustomerExperience />} />
          <Route path="/accelerate-decisions" element={<AccelerateDecisions />} />
          <Route path="/our-approach" element={<OurApproach />} />
          <Route path="/why-us" element={<WhyUs />} />
          <Route path="/roi-calculator" element={<ROICalculator />} />
          <Route path="/nutraceutical-ai-plan" element={<NutraceuticalAIPlan />} />
          <Route path="/coi-calculator" element={<CostOfInaction />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/ai-readiness" element={<AIReadiness />} />
          <Route path="/resources/ai-strategy-roadmap" element={<AIStrategyRoadmap />} />
          <Route path="/services/consulting/data-audit" element={<DataAudit />} />
          <Route path="/services/consulting/use-cases" element={<UseCaseIdentification />} />
          <Route path="/services/consulting/scoping-roi" element={<ProjectScopingROI />} />
          <Route path="/services/consulting/future-market-insights" element={<FutureMarketInsights />} />
          <Route path="/resources/benchmarking" element={<BenchmarkingCalculator />} />
          <Route path="/resources/industry-reports" element={<IndustryReports />} />
          <Route path="/services/dev/chatbots" element={<ChatbotsAgents />} />
          <Route path="/services/dev/automation" element={<WorkflowAutomation />} />
          <Route path="/services/dev/idp" element={<IntelligentDocumentProcessing />} />
          <Route path="/services/dev/genai" element={<GenerativeAIIntegration />} />
          {/* Training – not implemented yet → Coming Soon */}
          <Route path="/services/training/certifications" element={<ComingSoon />} />
          <Route path="/services/training/tooling" element={<ComingSoon />} />
          <Route path="/services/training/prompt-engineering" element={<ComingSoon />} />
          <Route path="/services/training/mlops" element={<ComingSoon />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/admin" element={<BlogControlPanel />} />
          <Route path="/admin/blog" element={<BlogControlPanel />} />
          <Route path="/knowledge-center" element={<KnowledgeCenter />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<Home />} />
        </Routes>
        <PremiumFloatingButton />
        <ScrollProgress />
        <BackToTop />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
